module.exports = __webpack_public_path__ + "img/SaleImg.9923ac2a.png";